import { Chip, Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import CheckIcon from '@mui/icons-material/Check';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { TFunction } from 'i18next';

interface StateConfig {
  icon: React.ReactElement;
  color: 'default' | 'info' | 'warning' | 'success' | 'error';
}

const stateConfig: Record<string, StateConfig> = {
  EDITABLE: {
    icon: <LockOpenIcon />,
    color: 'info'
  },
  LOCKED: {
    icon: <LockIcon />,
    color: 'warning'
  },
  SENT: {
    icon: <CheckIcon />,
    color: 'success'
  }
};

function movementStateCell(t: TFunction) {
  return function renderCell(params: GridRenderCellParams) {
    const state = params.value as string;

    if (!state) {
      return null;
    }

    const config = stateConfig[state] || {
      icon: <HelpOutlineIcon />,
      color: 'default' as const
    };

    const label = t(`entities.movement.state.${state}`, { defaultValue: state });

    return (
      <Tooltip title={label} arrow placement="top">
        <Chip
          icon={config.icon}
          label={label}
          color={config.color}
          size="small"
          variant="outlined"
        />
      </Tooltip>
    );
  };
}

export default movementStateCell;
